import { createReducer } from "typesafe-actions";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import RecordsPastDueCardConfiguration from "@app/types/dashboard/cards/recordsPastDue/RecordsPastDueCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyRecordsPastDueDrillDownListViewSettings,
  fetchRecordsPastDueCardDrillDownData,
  hideRecordsPastDueDrillDown,
  RecordsPastDueCardActions,
  showRecordsPastDueDrillDown,
} from "./actions";

export interface RecordsPastDueCardState {
  configuration?: RecordsPastDueCardConfiguration; // also works as a "visible" trigger, visible if set
  loading?: boolean;
  totalFilteredRecords: number;
  totalRecords: number;
  viewState: DrillDownViewState;
}

export const recordsPastDueInitialState: RecordsPastDueCardState = {
  // data: [],
  totalFilteredRecords: 0,
  totalRecords: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const recordsPastDueState = createReducer<RecordsPastDueCardState, RecordsPastDueCardActions>(
  recordsPastDueInitialState
)
  .handleAction(showRecordsPastDueDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
  }))
  .handleAction(showRecordsPastDueDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideRecordsPastDueDrillDown, (state) => ({ ...state, configuration: undefined }))
  .handleAction(fetchRecordsPastDueCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchRecordsPastDueCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    // data: payload.data,
    loading: false,
    totalFilteredRecords: payload.totalFilteredRecords,
    totalRecords: payload.totalRecords,
  }))
  .handleAction(fetchRecordsPastDueCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyRecordsPastDueDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default recordsPastDueState;
